module.exports = __webpack_public_path__ + "static/img/JYFA-09.2fd79e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solution/JYFA-09.jpg
// module id = ZzPY
// module chunks = 1